import axios from 'axios';
import { api } from './client';
import { AdminLoginRequest, RefreshTokenRequest, TokenResponse } from './types';

const baseURL = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8084';

export const loginRequest = async (payload: AdminLoginRequest): Promise<TokenResponse> => {
  const { data } = await api.post<TokenResponse>('/auth/login', payload);
  return data;
};

// Use plain axios (not the intercepted api) to avoid infinite refresh loops
export const refreshTokenRequest = async (refreshToken: string): Promise<TokenResponse> => {
  const payload: RefreshTokenRequest = { refreshToken };
  const { data } = await axios.post<TokenResponse>(`${baseURL}/auth/refresh`, payload);
  return data;
};

export const logoutRequest = async (refreshToken: string): Promise<void> => {
  const payload: RefreshTokenRequest = { refreshToken };
  await axios.post(`${baseURL}/auth/logout`, payload);
};
